import techupImage from "../assets/tech upskill.png";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  function goToLogin() {
    navigate("/login");
  }

  return (
    <div className="bg-[black] p-4 fixed w-screen flex fle-row justify-between">
      <div className="h-[40px]">
        <img src={techupImage} className=" h-[100%]" alt={techupImage} />
      </div>
      <div
        className="text-white pr-8 font-bold pt-2 cursor-pointer"
        onClick={goToLogin}>
        Login
      </div>
    </div>
  );
};

export default Header;
